
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventFlowItem } from '@/model/event-flow/EventFlow';
import { Field } from '@/model/table/Field';
import {
    formatToNormalDate,
    differenceInTime,
    formatToTime,
} from '@/lib/date-util';

@Component({
    methods: {
        formatToNormalDate,
        differenceInTime,
        formatToTime,
    },
})
export default class EventFlowTable extends Vue {
    @Prop(Date) readonly startDateTime!: Date;

    @Prop(Date) readonly endDateTime!: Date;

    @Prop() readonly eventFlowItems!: EventFlowItem[];

    toggled = false;

    private getLocationOrder(eventFlowItem: EventFlowItem): number {
        return eventFlowItem.location?.order ?? Number.POSITIVE_INFINITY;
    }

    get getCurrentEventFlowItems(): EventFlowItem[] {
        return this.eventFlowItems
            .filter(
                (eventFlowItem) =>
                    eventFlowItem.endedAt >= this.startDateTime &&
                    eventFlowItem.startedAt <= this.endDateTime,
            )
            .sort((first, last) => {
                return (
                    this.getLocationOrder(first) -
                        this.getLocationOrder(last) ||
                    first.startedAt.getTime() - last.startedAt.getTime() ||
                    first.endedAt.getTime() - last.endedAt.getTime()
                );
            });
    }

    get hasDetailedItems(): boolean {
        return this.getCurrentEventFlowItems.some((item) =>
            this.hasDescription(item),
        );
    }

    hasDescription(eventFlowItem: EventFlowItem): boolean {
        return Boolean(eventFlowItem.description?.trim());
    }

    get getFields(): Field[] {
        return [
            {
                key: 'brief',
                label: this.$i18n.t('event-flow.table.brief').toString(),
            },
            {
                key: 'startedAt',
                label: this.$i18n.t('event-flow.table.started-at').toString(),
            },
            {
                key: 'endedAt',
                label: this.$i18n.t('event-flow.table.ended-at').toString(),
            },
            {
                key: 'totalTime',
                label: this.$i18n.t('event-flow.table.total-time').toString(),
            },
            {
                key: 'locationName',
                label: this.$i18n
                    .t('event-flow.table.location-name')
                    .toString(),
            },
            {
                key: 'topic',
                label: this.$i18n.t('event-flow.table.topic').toString(),
            },
            {
                key: 'responsible',
                label: this.$i18n.t('event-flow.table.responsible').toString(),
            },
            {
                class: 'details-column',
                key: 'details',
                label: this.$i18n.t('event-flow.table.details').toString(),
            },
        ];
    }
    toggleAll(): void {
        this.toggled = !this.toggled;
        this.getCurrentEventFlowItems
            .filter((item) => this.hasDescription(item))
            .forEach((item) => {
                this.$set(item, '_showDetails', this.toggled);
            });
    }
}
